import React from 'react';
import { motion } from 'framer-motion';
import { hoverLift } from '../../utils/animations';

const Card = ({
  children,
  className = '',
  hover = true,
  padding = 'p-6',
  ...props
}) => {
  const baseStyles = 'bg-white rounded-xl shadow-md transition-all duration-300';

  return (
    <motion.div
      whileHover={hover ? hoverLift : {}}
      className={`${baseStyles} ${padding} ${className}`}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default Card;
